import _classCallCheck from "/tmp/builds/e9f06c32-c5e2-4b2a-88ab-461b5f7b1dc8-develop-nodeV18-18/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/tmp/builds/e9f06c32-c5e2-4b2a-88ab-461b5f7b1dc8-develop-nodeV18-18/node_modules/@babel/runtime/helpers/esm/createClass.js";
//Const
var NOAH_ARK_CAPACITY = 3;
export var EntryType;

(function (EntryType) {
  EntryType[EntryType["Marker"] = 0] = "Marker";
  EntryType[EntryType["Element"] = 1] = "Element";
})(EntryType = EntryType || (EntryType = {}));

var MARKER = {
  type: EntryType.Marker
}; //List of formatting elements

export var FormattingElementList = /*#__PURE__*/function () {
  function FormattingElementList(treeAdapter) {
    _classCallCheck(this, FormattingElementList);

    this.treeAdapter = treeAdapter;
    this.entries = [];
    this.bookmark = null;
  } //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.


  _createClass(FormattingElementList, [{
    key: "_getNoahArkConditionCandidates",
    value: function _getNoahArkConditionCandidates(newElement, neAttrs) {
      var candidates = [];
      var neAttrsLength = neAttrs.length;
      var neTagName = this.treeAdapter.getTagName(newElement);
      var neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);

      for (var i = 0; i < this.entries.length; i++) {
        var entry = this.entries[i];

        if (entry.type === EntryType.Marker) {
          break;
        }

        var element = entry.element;

        if (this.treeAdapter.getTagName(element) === neTagName && this.treeAdapter.getNamespaceURI(element) === neNamespaceURI) {
          var elementAttrs = this.treeAdapter.getAttrList(element);

          if (elementAttrs.length === neAttrsLength) {
            candidates.push({
              idx: i,
              attrs: elementAttrs
            });
          }
        }
      }

      return candidates;
    }
  }, {
    key: "_ensureNoahArkCondition",
    value: function _ensureNoahArkCondition(newElement) {
      if (this.entries.length < NOAH_ARK_CAPACITY) return;
      var neAttrs = this.treeAdapter.getAttrList(newElement);

      var candidates = this._getNoahArkConditionCandidates(newElement, neAttrs);

      if (candidates.length < NOAH_ARK_CAPACITY) return; //NOTE: build attrs map for the new element, so we can perform fast lookups

      var neAttrsMap = new Map(neAttrs.map(function (neAttr) {
        return [neAttr.name, neAttr.value];
      }));
      var validCandidates = 0; //NOTE: remove bottommost candidates, until Noah's Ark condition will not be met

      for (var i = 0; i < candidates.length; i++) {
        var candidate = candidates[i]; // We know that `candidate.attrs.length === neAttrs.length`

        if (candidate.attrs.every(function (cAttr) {
          return neAttrsMap.get(cAttr.name) === cAttr.value;
        })) {
          validCandidates += 1;

          if (validCandidates >= NOAH_ARK_CAPACITY) {
            this.entries.splice(candidate.idx, 1);
          }
        }
      }
    } //Mutations

  }, {
    key: "insertMarker",
    value: function insertMarker() {
      this.entries.unshift(MARKER);
    }
  }, {
    key: "pushElement",
    value: function pushElement(element, token) {
      this._ensureNoahArkCondition(element);

      this.entries.unshift({
        type: EntryType.Element,
        element: element,
        token: token
      });
    }
  }, {
    key: "insertElementAfterBookmark",
    value: function insertElementAfterBookmark(element, token) {
      var bookmarkIdx = this.entries.indexOf(this.bookmark);
      this.entries.splice(bookmarkIdx, 0, {
        type: EntryType.Element,
        element: element,
        token: token
      });
    }
  }, {
    key: "removeEntry",
    value: function removeEntry(entry) {
      var entryIndex = this.entries.indexOf(entry);

      if (entryIndex >= 0) {
        this.entries.splice(entryIndex, 1);
      }
    }
    /**
     * Clears the list of formatting elements up to the last marker.
     *
     * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
     */

  }, {
    key: "clearToLastMarker",
    value: function clearToLastMarker() {
      var markerIdx = this.entries.indexOf(MARKER);

      if (markerIdx >= 0) {
        this.entries.splice(0, markerIdx + 1);
      } else {
        this.entries.length = 0;
      }
    } //Search

  }, {
    key: "getElementEntryInScopeWithTagName",
    value: function getElementEntryInScopeWithTagName(tagName) {
      var _this = this;

      var entry = this.entries.find(function (entry) {
        return entry.type === EntryType.Marker || _this.treeAdapter.getTagName(entry.element) === tagName;
      });
      return entry && entry.type === EntryType.Element ? entry : null;
    }
  }, {
    key: "getElementEntry",
    value: function getElementEntry(element) {
      return this.entries.find(function (entry) {
        return entry.type === EntryType.Element && entry.element === element;
      });
    }
  }]);

  return FormattingElementList;
}();